import axios from '@/libs/api.request'

// 查询SKU 查询全部
export const queryPreSortingSkuType1 = (data) => {
	return axios.request({
		url: '/api/v1/preSorting/queryPreSortingSkuType1',
		params: data,
		method: 'get',
	})
};

// 查询SKU 根据销售情况查询
export const queryPreSortingSkuType2 = (data) => {
	return axios.request({
		url: '/api/v1/preSorting/queryPreSortingSkuType2',
		params: data,
		method: 'get',
	})
};

// 查询sku预分拣记录
export const queryPreSortingBySku = (data) => {
	return axios.request({
		url: '/api/v1/preSorting/queryPreSortingBySku',
		params: data,
		method: 'get',
	})
};

// 查询sku预分拣记录明细(参考销售情况)
export const queryPreSortingDetailBySku = (data) => {
	return axios.request({
		url: '/api/v1/preSorting/queryPreSortingDetailBySku',
		params: data,
		method: 'get',
	})
};

// 查询sku预分拣记录
export const createPrePack = (data) => {
	return axios.request({
		url: '/api/v1/preSorting/createPrePack',
		data,
		method: 'post',
	})
};

// 删除预分拣记录
export const deletePrePack = (data) => {
	return axios.request({
		url: '/api/v1/preSorting/deletePrePack',
		data,
		method: 'post',
	})
};

// 查询预分拣单据By分拣单ID
export const queryPreSortingByIds = (data) => {
	return axios.request({
		url: '/api/v1/preSorting/queryPreSortingByIds',
		data,
		method: 'post',
	})
};








// WEBPACK FOOTER //
// ./src/api/sorting/preSorting.js